import { Outlet } from "react-router-dom";
import { Box, styled, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import sizeConfigs from "../../configs/sizeConfigs";

import colorConfigs from "../../configs/colorConfigs";
import React from "react";
import Sidebar from "../Sidebar";
import ProfileButton from "../common/buttons/ProfileButton";

const AltLayout = () => {
  return (
      <Box
          sx={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            padding: 1,
          }}
        >
        <Outlet/>
      </Box>
  );
};

export default AltLayout;